import { REDUX_STATE } from 'modules/redux/constants/state'
import setUtil from 'utils/set'
import { REDUX_PUBLIC_DOMAINS } from 'modules/redux/constants/public-domains.js'
import {
  getObjectUtil,
  omitObjectUtil,
  pickObjectUtil
} from 'packages/src'

function resetReduxReducer (state, action) {
  const {
    path,
    keysToOmit = []
  } = action.payload
  if (!path) {
    return {
      ...REDUX_STATE,
      ...pickObjectUtil(state, REDUX_PUBLIC_DOMAINS)
    }
  }
  const defaultState = getObjectUtil(REDUX_STATE, path)
  const currentState = getObjectUtil(state, path)
  return setUtil(state, path, {
    ...currentState,
    ...omitObjectUtil(defaultState, keysToOmit)
  })
}

export default resetReduxReducer
